import { Typography } from '@room-match/shared-ui-components';
import React from 'react';
import { IAuditionScheduleAnswers } from 'shared/interfaces/IAuditionSchedule';
import { IAnswers } from 'shared/interfaces/ISession';
import { getCleanStringWithCommas } from 'shared/utils/getCleanStringWithCommas';

import { FlexContainer, MainContainer, TextSwitchColor } from './QAndA.styles';

type Props = {
  data?: Array<IAuditionScheduleAnswers> | null;
};
const QAndA: React.FC<Props> = ({ data }) => {
  return (
    <MainContainer>
      {data && data.length > 0 ? (
        data.map((i) => (
          <FlexContainer>
            <Typography color="primary">{i.question.inquiry}</Typography>
            <TextSwitchColor size={16}>{i.answer}</TextSwitchColor>
          </FlexContainer>
        ))
      ) : (
        <Typography fontSize={14}>No Data Available</Typography>
      )}
    </MainContainer>
  );
};

export default QAndA;
